
import { AccountTnc, BaseReducerState } from '../../../services'
import { AccountTncAPIResponse } from '../../../services/tnc'
import { ActionTypes } from '../actions'

export type AccountTncState = BaseReducerState & {
  data: AccountTnc
}

export const initialState: AccountTncState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const getAccountTncState = (
  state: AccountTncState = initialState,
  action: { type: string; res: any }
): AccountTncState => {
  switch (action.type) {
    case `${ActionTypes.GET_TNC}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.GET_TNC}_SUCCESS`: {
      const { success, data, message } = <AccountTncAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.GET_TNC}_FAILURE`:
      const res = <AccountTncAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.GET_TNC}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
